import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { roleGuard } from "./guards/role.guard";

const routes: Routes = [
  {
    path: "capabilitymap",
    loadChildren: () =>
      import("./capabilities-viz/capabilities-viz.module").then(
        (m) => m.CapabilitiesVizModule,
      ),
  },
  {
    path: "",
    loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
  },
  { path: "home", redirectTo: "", pathMatch: "full" },
  { path: "certifications/new", redirectTo: "/", pathMatch: "full" },
  {
    path: "skills-taxonomy",
    loadChildren: () =>
      import("./capabilities-viz/capabilities-viz.module").then(
        (m) => m.CapabilitiesVizModule,
      ),
  },
  {
    path: "consultant",
    loadChildren: () =>
      import("./consultant-skill/consultant-skill.module").then(
        (m) => m.ConsultantSkillModule,
      ),
  },
  {
    path: "build-team",
    loadChildren: () =>
      import("./build-team/build-team.module").then((m) => m.BuildTeamModule),
  },
  {
    path: "skills",
    loadChildren: () =>
      import("./skill/skill.module").then((m) => m.SkillModule),
  },
  {
    path: "release-notes",
    loadChildren: () =>
      import("./release-notes/release-notes.module").then(
        (m) => m.ReleaseNotesModule,
      ),
  },
  {
    path: "certifications",
    loadChildren: () =>
      import("./certifications/certifications.module").then(
        (m) => m.CertificationsModule,
      ),
  },
  {
    path: "skill-types",
    loadChildren: () =>
      import("./skill-type/skill-type.module").then((m) => m.SkillTypeModule),
    canActivate: [roleGuard(["TaxonomyAdministrator", "SkillsAdministrator"])],
  },
  { path: "skill-type", redirectTo: "skill-types", pathMatch: "full" },
  {
    path: "skill-alias",
    loadChildren: () =>
      import("./skill-alias/skill-alias.module").then(
        (m) => m.SkillAliasModule,
      ),
    canActivate: [roleGuard(["TaxonomyAdministrator", "SkillsAdministrator"])],
  },
  {
    path: "capabilities",
    loadChildren: () =>
      import("./capabilities/capabilities.module").then(
        (m) => m.CapabilitiesModule,
      ),
    canActivate: [
      roleGuard(["CapabilityAdministrator", "SkillsAdministrator"]),
    ],
  },
  {
    path: "skill-groups",
    loadChildren: () =>
      import("./skill-groups/skill-groups.module").then(
        (m) => m.SkillGroupsModule,
      ),
    canActivate: [roleGuard(["TaxonomyAdministrator", "SkillsAdministrator"])],
  },
  {
    path: "skill-statistics",
    loadChildren: () =>
      import("./skill-statistics/skill-statistics.module").then(
        (m) => m.SkillStatisticsModule,
      ),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/azure-sync",
    loadComponent: () =>
      import("./admin/azure-sync/admin-azure-sync.component").then(
        (m) => m.AdminAzureSyncComponent,
      ),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/active-profiles",
    loadComponent: () =>
      import("./admin/active-profiles/admin-active-profiles.component").then(
        (m) => m.AdminActiveProfilesComponent,
      ),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/hidden-profiles",
    loadComponent: () =>
      import("./admin/hidden-profiles/admin-hidden-profiles.component").then(
        (m) => m.AdminHiddenProfilesComponent,
      ),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/duplicate-profiles",
    loadComponent: () =>
      import(
        "./admin/duplicate-profiles/admin-duplicate-profiles.component"
      ).then((m) => m.AdminDuplicateProfilesComponent),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/search-statistics",
    loadComponent: () =>
      import(
        "./admin/search-statistics/admin-search-statistics.component"
      ).then((m) => m.AdminSearchStatisticsComponent),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/profile-statistics",
    loadComponent: () =>
      import(
        "./admin/profile-statistics/admin-profile-statistics.component"
      ).then((m) => m.AdminProfileStatisticsComponent),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/certification-statistics",
    loadComponent: () =>
      import(
        "./admin/certification-statistics/admin-certification-statistics.component"
      ).then((m) => m.AdminCertificationStatisticsComponent),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/industry-statistics",
    loadComponent: () =>
      import(
        "./admin/industry-statistics/admin-industry-statistics.component"
      ).then((m) => m.AdminIndustryStatisticsComponent),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/capability-statistics",
    loadComponent: () =>
      import(
        "./admin/capability-statistics/admin-capability-statistics.component"
      ).then((m) => m.AdminCapabilityStatisticsComponent),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/pi-manager",
    loadComponent: () =>
      import("./admin/pi-manager/admin-pi-manager.component").then(
        (m) => m.AdminPiManagerComponent,
      ),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/stale-profiles",
    loadComponent: () =>
      import("./admin/stale-profiles/admin-stale-profiles.component").then(
        (m) => m.AdminStaleProfilesComponent,
      ),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/incomplete-profiles",
    loadComponent: () =>
      import(
        "./admin/incomplete-profiles/admin-incomplete-profiles.component"
      ).then((m) => m.AdminIncompleteProfilesComponent),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/cert-expiry",
    loadComponent: () =>
      import("./admin/cert-expiry/admin-cert-expiry.component").then(
        (m) => m.AdminCertExpiryComponent,
      ),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "admin/onboarding",
    loadComponent: () =>
      import("./admin/onboarding/admin-onboarding.component").then(
        (m) => m.AdminOnboardingComponent,
      ),
    canActivate: [roleGuard(["SkillsAdministrator"])],
  },
  {
    path: "no-access",
    loadComponent: () =>
      import("./no-access/no-access.component").then(
        (m) => m.NoAccessComponent,
      ),
  },
  {
    path: "forbidden",
    loadComponent: () =>
      import("./forbidden/forbidden.component").then(
        (m) => m.ForbiddenComponent,
      ),
  },
  {
    path: "not-found",
    loadComponent: () =>
      import("./not-found/not-found.component").then(
        (m) => m.NotFoundComponent,
      ),
  },
  { path: "**", redirectTo: "not-found" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
